import { Button, Card, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Paper, Step, StepContent, StepLabel, Stepper, TextField, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  submitButtonWudaq: {
    marginTop: theme.spacing(0),
    width: '100%'
  },
  button: {
    marginTop: theme.spacing(1),
    width: '50%'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  divider: {
    backgroundColor: '#FF9800'
  }
}));



function SmsPermission(props) {

  const classes = useStyles();

  const [loading] = useState(false);

  const [telefonOffline, settelefonOffline] = useState('');
  const [telefon2Offline, settelefon2Offline] = useState('');
  const [telefon, settelefon] = useState('');
  const [telefon2, settelefon2] = useState('');
  const [smsKod, setsmsKod] = useState('');
  const [smsETKKod, setsmsETKKod] = useState('');
  const [alinanKodKVKK, setalinanKodKVKK] = useState("");
  const [alinanKodETK, setalinanKodETK] = useState("");
  const [smsSent, setSmsSent] = useState(false);
  const [smsSentCount, setSmsSentCount] = useState(1);
  const [alertVal, setAlertVal] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('success');
  const [lastTelefon, setLastTelefon] = useState('');

  const [seconds, setSeconds] = React.useState(0);

  const [activeStep, setActiveStep] = React.useState(0);
  const steps = ["Müşteri KVKK İzini", "Müşteri ETK İzini", 'Onayla'];

  React.useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => setSeconds(seconds - 1), 1000);
    }
  });

  const SmsData = props.readonly
    ? props.tasks.tasks.filter((d) => parseInt(d.FisNo, 10) === parseInt(props.FisNo, 10))
    : loadBaslandiJob();
  let MusteriNo = SmsData[0]?.MusteriNo;
  let FisNo = SmsData[0]?.FisNo;
  useEffect(() => {
    const TelefonOffline = SmsData[0]?.TelefonOffline;
    const Telefon = SmsData[0]?.Telefon;
    const Telefon2Offline = SmsData[0]?.Telefon2Offline;
    const Telefon2 = SmsData[0]?.Telefon2;
    const Smskod = SmsData[0]?.SmsKod;
    const ETKsmskod = SmsData[0]?.ETKSmsKod

    settelefonOffline(TelefonOffline);
    settelefon(Telefon);
    settelefon2Offline(Telefon2Offline);
    settelefon2(Telefon2);
    setsmsKod(Smskod);
    setsmsETKKod(ETKsmskod);
    // if (SmsData[0]?.KVKK_DOGRULAMA === 1) { setActiveStep(1) }
  }, [SmsData]);

  const inputChangeKVKK = (event) => {
    setalinanKodKVKK(event.target.value);
  };

  const inputChangeETK = (event) => {
    setalinanKodETK(event.target.value);
  };

  const openAlertMessage = (text) => {
    setAlertMessage(text);
    setAlertVal(true);
  };

  const handleNext = () => {

    axios.get(`/GetDbCodePermision/${loadBaslandiJob()[0]?.MusteriNo}`)
      .then(response => {

        setsmsKod(response.data[0]?.IZIN_KODU || '');
        setsmsETKKod(response.data[0]?.ETK_KODU || '');

        var smsKodParam = response.data[0]?.IZIN_KODU || '';
        var smsETKKodParam = response.data[0]?.ETK_KODU || '';



        if (activeStep === 0 && alinanKodKVKK.length > 0) {
          if (props.PermissionChannela.length === 0) {
            openAlertMessage('İzin Alınan kanal bulunamadı,çıkmak için lütfen kapat butonunu kullanınız.');
            setAlertType('error');
          } else if (smsKodParam !== alinanKodKVKK) {
            openAlertMessage('Hatalı Sms Kodu');
            setAlertType('error');
          } else {
            let job = loadBaslandiJob()[0];
            job = {
              ...job,
              ALINAN_SMS_KOD: smsKodParam,
              FARKLI_SMS: false,
              KVKK_DOGRULAMA: 1,
              FarkliSms: false,
              SMS_DOGRULAMA: 1,
            }
            saveBaslandiJob(job);
            const dataSetPermision = [{
              ServicePaperNr: loadBaslandiJob()[0]?.FisNo,
              CustomerNr: loadBaslandiJob()[0]?.MusteriNo,
              Permision: 1,
            }];
            const configSetPermision = {
              headers: { 'Content-Type': 'application/json' }
            };
            axios.post('/SetPermision', dataSetPermision, configSetPermision)
              .catch(error => {
                logger.error("Hata detayı:", error.message);
              });
            openAlertMessage('İzin onaylanmıştır.');
            setAlertType('success');
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
          }
        }
        if (activeStep === 1 && alinanKodETK.length > 0) {
          // if (props.PermissionChannela.length === 0) {
          //   openAlertMessage('İzin Alınan kanal bulunamadı,çıkmak için lütfen kapat butonunu kullanınız.');
          //   setAlertType('error');
          // } else 
          if (smsETKKodParam !== alinanKodETK) {
            openAlertMessage('Hatalı Sms Kodu');
            setAlertType('error');
          } else {
            let job = loadBaslandiJob()[0];
            job = {
              ...job,
              AramaIzin: 1,
              ETKIzin: 1,
              ALINAN_ETK_KOD: smsETKKodParam
            }
            saveBaslandiJob(job);
            const dataSetPermision = [{
              ServicePaperNr: loadBaslandiJob()[0]?.FisNo,
              CustomerNr: loadBaslandiJob()[0]?.MusteriNo,
              Permision: 2,
            }];
            const configSetPermision = {
              headers: { 'Content-Type': 'application/json' }
            };
            axios.post('/SetPermision', dataSetPermision, configSetPermision)
              .then(_response => {
                // if (activeStep !== steps.length - 1) {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
                smsSend(smsETKKod, lastTelefon, 3)
                return;
                // }
              }).catch(error => {
                logger.error("Hata detayı:", error.message);
              });
            openAlertMessage('İzin onaylanmıştır.');
            var index = props.PermissionChannela.indexOf('AramaIzin');
            props.PermissionChannela.splice(index, 1);
          }
        } if (activeStep === 2) {
          props.setOpen(false);
        }




      }).catch(error => {
        setAlertType('error');
        openAlertMessage('Sms Kod Alınamadı. Lütfen tekrar deneyiniz!...');
        logger.error("Hata detayı:", error.message);
      });










  };


  const smsSend = (smsKod, telefon, type) => {
    setLastTelefon(telefon);
    const smsText = "";
    const dataPermision = [{
      smsText: smsText,
      Phone: telefon,
      Brand: 'ARCELIK',
      CustomerNr: MusteriNo,
      ServicePaperNr: FisNo,
      TextType: type
    }];
    const configPermision = {
      headers: { 'Content-Type': 'application/json' }
    };
    setSmsSent(true);
    const count = smsSentCount;
    setSmsSentCount(count + 1);
    axios.post('/SmsSendPermision', dataPermision, configPermision)
      .then(_response => {
        openAlertMessage('Sms Müşteriye iletildi');
        setTimeout(() => setSmsSent(false), 30000);
        setSeconds(30);
      }).catch(error => {
        openAlertMessage('İç Sunucu Kaynaklı Sms İletilemedi.');
        setSmsSent(false);
        logger.error("Hata detayı:", error.message);
      });
  };



  function getStepContent(step) {
    switch (step) {
      case 0:
        if (SmsData?.length === 0)
          return <div></div>;
        return <div>
          <form>
            {
              (props.PermissionChannela.length > 0)
              && (
                <Card>
                  <Divider className={classes.divider} />
                  {
                    telefonOffline !== "" && telefonOffline?.substring(0, 1) === "5" ?
                      <Typography variant="body1">
                        <Button
                          color="secondary"
                          onClick={() => smsSend(smsKod, telefonOffline, 1)}
                          variant="contained"
                          disabled={props.smsSenta}
                          className={classes.submitButton}
                          endIcon={<SendIcon>Send</SendIcon>}
                        >
                          {(!smsSent && ((smsSentCount > 1) ? `(${smsSentCount})` : '') + telefon + ' Tel1 Kodu Gönder') || (smsSent && `${seconds}snBekleyiniz..`)}
                        </Button>
                      </Typography>
                      : <div></div>
                  }
                  {
                    telefon2Offline !== "" && telefon2Offline?.substring(0, 1) === "5" ?
                      <Typography variant="body1">
                        <Button
                          color="secondary"
                          onClick={() => smsSend(smsKod, telefon2Offline, 1)}
                          variant="contained"
                          disabled={props.smsSent}
                          className={classes.submitButton}
                          endIcon={<SendIcon>Send</SendIcon>}
                        >
                          {(!smsSent && ((smsSentCount > 1) ? `(${smsSentCount})` : '') + telefon2 + ' Tel2 Kodu Gönder') || (smsSent && `${seconds}snBekleyiniz..`)}
                        </Button>
                      </Typography>
                      : <div></div>
                  }
                  <Typography variant="body1" component="div">
                    <TextField id="outlined-basic"
                      label="KVKK İzin Onay Kodu" variant="outlined"
                      size="small"
                      autoComplete="off"
                      onChange={inputChangeKVKK}
                      className={classes.submitButton}
                    />
                  </Typography>
                  {/* <br />
                  <Typography variant="body1">
                    <TextField id="outlined-basic"
                      label="Yurt Dışı İzin Onay Kodu" variant="outlined"
                      size="small"
                      autoComplete="off"
                      onChange={inputChangeYD}
                      className={classes.submitButton}
                    />
                  </Typography> */}
                  <br />
                  <Divider className={classes.divider} />
                </Card>
              )
            }
          </form>
          <Divider />
        </div>;

      case 1:
        return <div className={classes.fields}>
          <Card>
            <Divider className={classes.divider} />
            {
              telefonOffline !== "" && telefonOffline?.substring(0, 1) === "5" ?
                <Typography variant="body1">
                  <Button
                    color="secondary"
                    onClick={() => smsSend(smsETKKod, telefonOffline, 2)}
                    variant="contained"
                    disabled={props.smsSenta}
                    className={classes.submitButton}
                    endIcon={<SendIcon>Send</SendIcon>}
                  >
                    {(!props.smsSent && ((props.smsSentCount > 1) ? `(${props.smsSentCount})` : '') + telefon + ' Tel1 Kodu Gönder') || (props.smsSent && `${seconds}snBekleyiniz..`)}
                  </Button>
                </Typography>
                : <div></div>
            }
            {
              telefon2Offline !== "" && telefon2Offline?.substring(0, 1) === "5" ?
                <Typography variant="body1">
                  <Button
                    color="secondary"
                    onClick={() => smsSend(smsETKKod, telefon2Offline, 2)}
                    variant="contained"
                    disabled={props.smsSent}
                    className={classes.submitButton}
                    endIcon={<SendIcon>Send</SendIcon>}
                  >
                    {(!props.smsSent && ((props.smsSentCount > 1) ? `(${props.smsSentCount})` : '') + telefon2 + ' Tel2 Kodu Gönder') || (props.smsSent && `${seconds}snBekleyiniz..`)}
                  </Button>
                </Typography>
                : <div></div>
            }
            <Typography variant="body1">
              <TextField id="outlined-basic"
                label="ETK İzin Onay Kodu" variant="outlined"
                size="small"
                onChange={inputChangeETK}
                autoComplete="off"
                className={classes.submitButton}
              />
            </Typography>
            <br />
            <Divider className={classes.divider} />
          </Card>
        </div>;
      case 2:
        return "Tüm işlemleriniz başarıyla tamamlanmıştır"
      default:
        return "";
    }
  }



  return (
    <>
      <Dialog
        open={props.open}
        onClose={() => props.setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullScreen>
        <DialogTitle id="alert-dialog-title">
          Tüketici KVK ve ETK İzinleri
          <Divider />
        </DialogTitle>
        <DialogContent>
          {loading && <CircularProgress
            status={'loading'}
            style={{ marginLeft: '50%' }}
          />}
          <Stepper activeStep={activeStep}
            orientation="vertical">
            {steps?.map((label, index) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
                <StepContent>
                  <br />
                  <br />
                  {getStepContent(index)}
                  <br />
                  <br />
                  <div className={classes.actionsContainer}>
                    <div>
                      {/* <Button
                        disabled={activeStep === 0 || loading}
                        variant="contained"
                        style={{ backgroundColor: '#FF9800', color: '#424242' }}
                        onClick={() => setActiveStep((prev) => prev - 1)}
                        startIcon={<KeyboardArrowLeft />}
                        className={classes.button}
                      >
                        Gerİ
                      </Button> */}

                      <Button
                        disabled={loading}
                        variant="contained"
                        color="secondary"
                        onClick={handleNext}
                        endIcon={<KeyboardArrowRight />}
                        className={classes.button}
                      >
                        {activeStep === steps.length - 1 ? "Kapat" : "İlerİ"}
                      </Button>
                    </div>
                  </div>
                </StepContent>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length && (
            <Paper square elevation={0} className={classes.resetContainer}>
              <Button onClick={() => setActiveStep(0)} className={classes.button}>
                Başa Dön
              </Button>
            </Paper>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => props.setOpen(false)}
            className={classes.submitButtonWudaq}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
        {
          alertVal
          && (<Alert onClose={() => setAlertVal(false)} open={alertVal} message={alertMessage || ''} variant={alertType} />)
        }
      </Dialog>
    </>
  );
}

export default SmsPermission;
